var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSquare44B = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M18 20.5a2.5 2.5 0 0 1 2.5-2.5h19a2.5 2.5 0 0 1 2.5 2.5v19a2.5 2.5 0 0 1-2.5 2.5h-19a2.5 2.5 0 0 1-2.5-2.5v-19ZM25 4h10l.752 8.274A2.5 2.5 0 0 1 33.262 15h-6.524a2.5 2.5 0 0 1-2.49-2.726L25 4Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m24 6 .223-.445A2.813 2.813 0 0 1 26.738 4h6.524c1.065 0 2.039.602 2.515 1.555L36 6"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M35 56H25l-.752-8.274A2.5 2.5 0 0 1 26.738 45h6.524a2.5 2.5 0 0 1 2.49 2.726L35 56Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m36 54-.223.445A2.813 2.813 0 0 1 33.262 56h-6.524a2.813 2.813 0 0 1-2.515-1.555L24 54"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M56 25v10l-8.274.752A2.5 2.5 0 0 1 45 33.262v-6.524a2.5 2.5 0 0 1 2.726-2.49L56 25Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m54 24 .445.223A2.813 2.813 0 0 1 56 26.738v6.524c0 1.065-.602 2.039-1.555 2.515L54 36"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M4 35V25l8.274-.752A2.5 2.5 0 0 1 15 26.738v6.524a2.5 2.5 0 0 1-2.726 2.49L4 35Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m6 36-.445-.223A2.813 2.813 0 0 1 4 33.262v-6.524c0-1.065.602-2.039 1.555-2.515L6 24"
})));
SvgSquare44B.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgSquare44B);
export default ForwardRef;